import userCoreService, {
  NewsletterData,
} from 'commons/api/userAccount/userCoreService';
import { isEqual, deepCopy } from 'commons/utils';
import { defineStore } from 'pinia';

type State = {
  data: NewsletterData;
  originalData: NewsletterData;
};

export const useUserNewsletterStore = defineStore('userNewsletter', {
  state: (): State => ({
    data: { customer: false, partner: false },
    originalData: { customer: false, partner: false },
  }),
  getters: {
    hasChanged: (state) => !isEqual(state.data, state.originalData),
  },

  actions: {
    setData(data: NewsletterData) {
      this.data = data;
      this.originalData = deepCopy(data);
    },
    reset() {
      this.data = deepCopy(this.originalData);
    },
    setCustomerNewsletter(subscribed: NewsletterData['customer']) {
      this.data.customer = subscribed;
    },
    setPartnerNewsletter(subscribed: NewsletterData['partner']) {
      this.data.partner = subscribed;
    },
    async fetchNewsletterData() {
      const data = await userCoreService.getNewsletterData();
      this.setData(data);
    },
    async saveNewsletterData() {
      const data = await userCoreService.updateNewsletterData(this.data);
      this.setData(data);
    },
  },
});
